/** CDN assets for the Performance Lab GLP-1 page. */
import { getCompressedAssetUrl } from 'lib/config/assetUrls';

export const GLP_PAGE_ASSET_BASE = 'web_v2/performance-lab/glp-page';

const GLP_ASSET_CACHE_VERSION = '?v=1';

/** Full Speedsize URL for plain `<img>` tags (HiDPI width baked in). */
export const glpPageAssetUrl = (path: string, width: number): string =>
  getCompressedAssetUrl(
    `/${GLP_PAGE_ASSET_BASE}/${path}${GLP_ASSET_CACHE_VERSION}/w_${width}`,
  );

/** Paths for HeroSection CustomImage (Speedsize loader adds the CDN prefix). */
const glpHeroImageSrc = (path: string, width: number): string =>
  `${GLP_PAGE_ASSET_BASE}/${path}${GLP_ASSET_CACHE_VERSION}/w_${width}`;

export const GLP_HERO_BACKGROUND = {
  desktop: glpHeroImageSrc('hero.png', 3000),
  mobile: glpHeroImageSrc('hero-min-v2.png', 1600),
};

export const GLP_EXPLORE_THUMB_SRC = glpPageAssetUrl('explore-thumb.png', 154);

export const GLP_LONGEVITY_IMAGE_SRC: Record<string, string> = {
  measurement: glpPageAssetUrl('protocol/measurement.png', 1120),
  guidance: glpPageAssetUrl('protocol/guidance.png', 1120),
  interventions: glpPageAssetUrl('protocol/intervention.png', 1120),
  response: glpPageAssetUrl('protocol/cgm.png', 1120),
};

export const GLP_GUIDED_IMAGE_SRC: Record<string, string> = {
  'doctor-led': glpPageAssetUrl('data-driven/doctor-led.png', 960),
  'nutritionist-driven': glpPageAssetUrl(
    'data-driven/nutritionist-driven.png',
    720,
  ),
  'action-plan': getCompressedAssetUrl(
    `/${GLP_PAGE_ASSET_BASE}/data-driven/performance-coaching-updated.png?v=2/w_720`,
  ),
  'biointelligence-ai': glpPageAssetUrl('data-driven/bio-ai.png', 720),
  'ultrahuman-vision': glpPageAssetUrl('data-driven/uh-vision-2.png', 720),
};

/** Journey chat — performance coach avatar (Aamir). */
export const GLP_PERFORMANCE_COACH_AVATAR_SRC = glpPageAssetUrl('aamir.png', 96);

export const GLP_JOURNEY_CHAT_BG_SRC: Record<string, string> = {
  'train-hard': glpPageAssetUrl('chat-bg/chat-1.png', 1280),
  'energy-crashes': glpPageAssetUrl('chat-bg/chat-2.png', 1280),
  foggy: glpPageAssetUrl('chat-bg/chat-3.png', 1280),
};

/** Science carousel cards — desktop 620×400, mobile 4:5 with source-min art. */
export const GLP_SCIENCE_IMAGE_SRC: Record<string, string> = {
  'glp-files': glpPageAssetUrl('science/uh-article-1.png', 1240),
  'semaglutide-cv': glpPageAssetUrl('science/nej-article-1.png', 1240),
  'semaglutide-mash': glpPageAssetUrl('science/nej-article-2.png', 1240),
  'semaglutide-kidney': glpPageAssetUrl('science/nej-article-3.png', 1240),
};

export const GLP_SCIENCE_IMAGE_SRC_MOBILE: Record<string, string> = {
  'glp-files': glpPageAssetUrl('science/source-min/uh-article-1.png', 860),
  'semaglutide-cv': glpPageAssetUrl('science/source-min/nej-article-1.png', 860),
  'semaglutide-mash': glpPageAssetUrl('science/source-min/nej-article-2.png', 860),
  'semaglutide-kidney': glpPageAssetUrl(
    'science/source-min/nej-article-3.png',
    860,
  ),
};
